import { lighten } from "@mui/material";

export const styles = {
  font_14_capital: {
    fontSize: 14,
    fontWeight: "bold",
    textTransform: "capitalize",
  },
  buttonStyles: (type, agentType, brandColor) => ({
    width: 120,
    height: 120,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 1,
    border: agentType === type ? `1px solid ${brandColor}` : "1px solid #ccc",
    backgroundColor: "#f9f9f9",
    color: agentType === type ? brandColor : "#000",
    "&:hover": {
      backgroundColor:
        agentType === type ? lighten(brandColor, 0.6) : "#f0f0f0",
    },
  }),
  slider: {
    color: "orange",
    "& .MuiSlider-thumb": {
      backgroundColor: "#E95500",
    },
    "& .MuiSlider-track": {
      backgroundColor: "#E95500",
    },
    "& .MuiSlider-rail": {
      backgroundColor: "#E95500",
    },
  },
  testAgentBody: {
    position: "absolute",
    right: 0,
    top: 0,
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    transition: "all 0.5s ease",
    zIndex: 2,
    paddingLeft: "16px",
  },
  animation: {
    textTransform: "none",
    color: "#666",
    mt: 2,
    display: "inline-block",
    overflow: "hidden",
    whiteSpace: "nowrap",
    borderRight: "2px solid #666",
    width: "0",
    animation: "typing 3s steps(25, end) infinite, blink 0.7s infinite",
    "@keyframes typing": {
      "0%": { width: "0%" },
      "100%": { width: "50%" },
    },
    "@keyframes blink": {
      "50%": { borderColor: "transparent" },
    },
  },
  testCard: {
    height: "100%",
    position: "relative",
    cursor: "pointer",
    transition: "0.3s ease-in-out",
    "&:hover": {
      boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
    },
  },
  testAgentModal: (status) => ({
    display: "inline-block",
    fontSize: 13,
    fontWeight: 600,
    px: 1.5,
    py: 0.5,
    borderRadius: 12,
    color:
      status === "success"
        ? "green"
        : status === "in_progress"
        ? "#FF9800"
        : "red",

    backgroundColor:
      status === "success"
        ? "#E8F5E9"
        : status === "in_progress"
        ? "#FFF3E0"
        : "#FFEBEE",
  }),
  testAgentModal2: (progressData) => ({
    width: `${parseFloat(progressData.progress)}%`,
    height: "100%",
    borderRadius: 4,
    transition: "width 0.5s ease-in-out",
    bgcolor: parseFloat(progressData.progress) === 100 ? "green" : "#1976D2",
  }),
  testBodyContainer: {
    maxHeight: "45vh",
    overflowY: "auto",
    mb: 4,
    pr: 1,
    "&::-webkit-scrollbar": { width: "6px" },
    "&::-webkit-scrollbar-thumb": {
      background: "#aaa",
      borderRadius: "10px",
    },
    "&::-webkit-scrollbar-track": { background: "#f0f0f0" },
  },
  testContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    p: 1,
    borderRadius: 1,
    bgcolor: "grey.100",
  },

  testStatusCard: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    p: 1,
    borderRadius: 1,
    transition: "background-color 0.3s ease-in-out",
  },
  statusText: (status) => ({
    px: 1.5,
    py: 0.5,
    borderRadius: 12,
    fontSize: 13,
    fontWeight: 600,
    textTransform: "capitalize",
    color: status === "success" ? "green" : "red",
    backgroundColor: status === "success" ? "#E8F5E9" : "#FFEBEE",
  }),
  suffixTextField: {
    "& .MuiOutlinedInput-root": {
      fontSize: 13,
      fontWeight: 400,
      border: "none",
      padding: 0,
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "& .MuiOutlinedInput-input": {
      padding: "15px",
      "&::placeholder": {
        color: "#555555",
        fontSize: 13,
        fontWeight: 400,
      },
    },
  },
  suffixBox: {
    border: "1px solid #CCD2DE",
    borderRadius: 2,
    overflow: "hidden",
    transition: "border-color 0.3s ease",
    width: "100%",
  },
  suffixText: {
    px: 2,
    fontSize: 13,
    fontWeight: 400,
    color: "#555555",
    whiteSpace: "nowrap",
  },
  linkTextBox: {
    backgroundColor: "#f5f5f5",
    padding: "12px 14px",
    borderRadius: "12px",
    border: "1px solid #ddd",
    maxWidth: "100%",
  },
  logoCrossIcon: {
    position: "absolute",
    top: -6,
    right: -6,
    backgroundColor: "#fff",
    border: "1px solid #ddd",
    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
    boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
    width: 20,
    height: 20,
    minWidth: 20,
  },
};
